import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { PropsWithChildren } from 'react';
import { reactPlugin } from '../analytics/app-insights';

const AppInsightsProvider = ({ children }: PropsWithChildren) => {
    return (
        <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>
    );
};

export default AppInsightsProvider;
